import React from 'react';
import { DollarSign } from 'lucide-react';
import { COLORS } from '../../../../utils/constants';

const SettingInput = ({ label, value, onChange, type = 'number', step = '1' }) => (
  <div>
    <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px' }}>
      {label}
    </label>
    <input
      type={type}
      step={step}
      value={value}
      onChange={(e) => onChange(type === 'number' ? parseFloat(e.target.value) : e.target.value)}
      style={{
        width: '100%',
        padding: '12px',
        backgroundColor: COLORS.background,
        border: `1px solid ${COLORS.border}`,
        borderRadius: '8px',
        color: COLORS.text,
        fontSize: '14px',
        boxSizing: 'border-box',
      }}
    />
  </div>
);

const PlatformSettingsSection = ({ settings, setSettings }) => {
  const updateSetting = (key, value) => {
    setSettings({ ...settings, [key]: value });
  };

  return (
    <div style={{
      backgroundColor: COLORS.card,
      borderRadius: '12px',
      padding: '20px',
      border: `1px solid ${COLORS.border}`,
    }}>
      <h3 style={{ color: COLORS.text, fontSize: '16px', fontWeight: '600', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
        <DollarSign size={20} color={COLORS.primary} />
        Настройки торговли
      </h3>
      
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
        <SettingInput
          label="Комиссия (%)"
          value={settings?.trading_fees || 0.1}
          onChange={(v) => updateSetting('trading_fees', v)}
          step="0.01"
        />
        
        <SettingInput
          label="Макс. плечо"
          value={settings?.max_leverage || 100}
          onChange={(v) => updateSetting('max_leverage', parseInt(v))}
        />
        
        <SettingInput
          label="Мин. сумма сделки ($)"
          value={settings?.min_trade_amount || 10}
          onChange={(v) => updateSetting('min_trade_amount', v)}
        />
        
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', flexDirection: 'column' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <input
              type="checkbox"
              id="maintenance"
              checked={settings?.maintenance_mode || false}
              onChange={(e) => updateSetting('maintenance_mode', e.target.checked)}
              style={{ width: '18px', height: '18px', accentColor: COLORS.danger }}
            />
            <label htmlFor="maintenance" style={{ 
              color: settings?.maintenance_mode ? COLORS.danger : COLORS.text, 
              fontSize: '14px', 
              fontWeight: settings?.maintenance_mode ? '600' : '400' 
            }}>
              🔧 Режим обслуживания
            </label>
          </div>
          <p style={{ color: COLORS.textSecondary, fontSize: '12px', margin: 0, paddingLeft: '30px' }}>
            При включении — торговля будет заблокирована для всех пользователей.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PlatformSettingsSection;
